// @ts-ignore
import store from "@/store"

async function handleTasksChanged() {
  await store.dispatch("tasks/getUnassignedCareTeamTasksCount")
  await store.dispatch("tasks/getAssignedTasksCount")
  await store.dispatch("tasks/checkShowTasksBadgeIn")
}

export default {
  handleTasksChanged
}
